import { ApexOptions } from "apexcharts";
import { ScoreData } from "entities";
import { DateTime } from "luxon";
import { useEffect, useState } from "react";
import Chart from "react-apexcharts";
import { Header, Segment, Container } from "semantic-ui-react";
import { Labels } from "utils/constants";

interface StackedChartProps {
  data: ScoreData[];
}
const StackedChart = ({ data }: StackedChartProps) => {
  const [axis, setAxis] = useState([]);
  const [series, setSeries] = useState([]);

  const options: ApexOptions = {
    chart: {
      type: "bar",
      stacked: true,
      toolbar: {
        show: true,
        tools: {
          zoom: true,
        },
      },
      zoom: {
        enabled: true,
      },
    },
    tooltip: {
      fillSeriesColor: false,
    },
    colors: ["#19ff19", "#ffff00", "#ffa500", "#ff0000"],
    legend: {
      position: "bottom",
      horizontalAlign: "center",
      floating: false,
      fontSize: "18px",
      fontFamily: "Helvetica, Arial",
      fontWeight: 400,
      offsetY: 9,
      markers: {
        width: 15,
        height: 15,
        strokeWidth: 0,
        radius: 15,
        offsetX: -3,
      },
      itemMargin: {
        horizontal: 10,
      },
    },
    fill: {
      opacity: 1,
    },
    xaxis: {
      type: "category",
      categories: axis,
    },
    plotOptions: {
      bar: {
        horizontal: false,
        borderRadius: 5,
      },
    },
    dataLabels: {
      enabled: true,
      // textAnchor: 'start',
      style: {
        colors: ["black"],
      },
    },
    responsive: [
      {
        breakpoint: 480,
        options: {
          chart: {
            width: 290,
            height: 400,
          },
          legend: {
            horizontalAlign: "left",
            floating: false,
            offsetY: 10,
            itemMargin: {
              horizontal: 9,
              vertical: 9,
            },
          },
        },
      },
      {
        breakpoint: 680,
        options: {
          chart: {
            width: 400,
            height: 500,
          },
          legend: {
            horizontalAlign: "left",
            floating: false,
            offsetY: 10,
            itemMargin: {
              horizontal: 9,
              vertical: 9,
            },
          },
        },
      },
    ],
  };

  useEffect(() => {
    const ax = [];
    setSeries(
      data
        .sort((a, b) => new Date(a.date).valueOf() - new Date(b.date).valueOf())
        .reduce(
          (acc, curr) => {
            ax.push(DateTime.fromISO(curr.date).toFormat("y-MM-dd"));
            acc[0].data.push(curr.score1);
            acc[1].data.push(curr.score2);
            acc[2].data.push(curr.score3);
            acc[3].data.push(curr.score4);
            return acc;
          },
          [
            { name: Labels[0], data: [] },
            { name: Labels[1], data: [] },
            { name: Labels[2], data: [] },
            { name: Labels[3], data: [] },
          ]
        )
    );
    setAxis(ax);
  }, [data]);

  return (
    <Segment id="piechart">
      <Header as="h3">Nombre de réponses</Header>
      <Container
        style={{
          display: "flex",
          justifyContent: "center",
          margin: "0 !important",
        }}
      >
        <Chart
          options={options}
          series={series}
          type="bar"
          width={780}
          style={{ margin: "auto" }}
        />
      </Container>
    </Segment>
  );
};

export { StackedChart };
